/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { Divider, Typography } from "@mui/material";

interface TimeSectionProps {
  timeInput: React.ReactNode;
}

const TimeSection = ({ timeInput }: TimeSectionProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div css={css({ padding: "16px 24px" })}>
        <Typography
          variant="body1Medium"
          component="div"
          css={css({ paddingBottom: "16px" })}
        >
          {t("Dialog##time")}
        </Typography>
        {timeInput}
      </div>
      <Divider />
    </>
  );
};

export default TimeSection;
